<template>
    <div class="hs-container">
        <div class="handle-box">
            <div class="handle-left">
                <div class="search-left">
                    <el-form :inline="true" ref="form" :model="query">
                        <el-form-item>
                            <el-select v-model="query.news_type" placeholder="信息类型">
                                <el-option v-for="item in newsTypeList" :key="item.id" :label="item.title" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item>
                            <el-date-picker v-model="query.date_range" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                            </el-date-picker>
                        </el-form-item>

                        <el-form-item>
                            <el-button type="primary" @click="getTableData">搜索</el-button>
                        </el-form-item>

                        <el-form-item>
                            <el-button type="warning">导出</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>

        <el-table :data="tableData" border>
            <el-table-column label="酒店" prop="hotel.title"></el-table-column>
            <el-table-column label="渠道" prop="source.title"></el-table-column>
            <el-table-column label="咨询数量" prop="totals" align="center"></el-table-column>
            <el-table-column label="有效数量" prop="available" align="center"></el-table-column>
            <el-table-column label="意向数量" prop="purpose" align="center"></el-table-column>
            <el-table-column label="进店数量" prop="store" align="center"></el-table-column>
            <el-table-column label="订单数量" prop="order" align="center"></el-table-column>
            <el-table-column label="转化率"></el-table-column>
        </el-table>
    </div>
</template>

<script>
import dictionary from '@/utils/dictionary.js';
import * as api from '../../../api/module'
const query = {
    hotel_id: [],
    news_type: '',
    date_range: []
};

export default {
    name: 'customerStatistics',
    data() {
        return {
            query: query,
            tableData: []
        };
    },
    computed: {
        newsTypeList: function () {
            return dictionary.getPicker('news_type');
        },
        hotelList: function () {
            let matched = [];
            let hotels = dictionary.getPicker('hotel')
            hotels.forEach(ele => {
                if (ele.title.indexOf("曼格纳艺术中心") >= 0) {
                    matched.push(ele);
                }
            });
            return matched;
        }
    },
    created() {

    },
    methods: {
        getTableData() {
            api.increase(this.query)
                .then(res => {
                    if (res.code == 200) {
                        this.tableData = res.data.group;
                    } else {
                        this.$message.error(res.msg);
                        return;
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        }
    }
};
</script>

<style lang="less" scoped>
@import url('@/assets/css/common.less');
.el-form-item--small.el-form-item {
    margin-bottom: 0 !important;
}
</style>
